import axios from 'axios';

export const projectService = {
  getProjects: (params) =>
    axios.get('/projects', { auth: true, params }),

  getProject: (id) =>
    axios.get(`/projects/${id}`, { auth: true }),

  createProject: (data) =>
    axios.post('/projects', data, { auth: true }),

  editProject: (id, data) =>
    axios.patch(`/projects/${id}`, data, { auth: true }),

  deleteProject: (id) =>
    axios.delete(`/projects/${id}`, { auth: true }),

  addMember: (projectId, userId) =>
    axios.post(`/projects/${projectId}/members`, { userId }, { auth: true }),

  removeMember: (projectId, userId) =>
    axios.delete(`/projects/${projectId}/members/${userId}`, { auth: true }),
};
